import {
  TLibrary,
  TSelectedLibraryOptions,
} from 'src/components/LibraryChooser/LibraryChooser.types';

import { LibraryTypesGraphql } from 'src/graphql';
import { formatSubtitle } from 'src/components/LibraryChooser/LibraryChooserHelpers';
import { v4 } from 'uuid';

type customParameterKeys =
  | 'isCustomPV'
  | 'isCustomHouse'
  | 'isCustomLoad'
  | 'isCustomHeatPump'
  | 'isCustomStorage'
  | 'isCustomWindTurbine'
  | 'isCustomSmartMeter';

const getCustomParameters = (key: customParameterKeys, value: boolean) => {
  const params = {
    isCustomHouse: true,
    isCustomPV: false,
    isCustomLoad: false,
    isCustomHeatPump: false,
    isCustomStorage: false,
    isCustomWindTurbine: false,
    isCustomSmartMeter: false,
  };

  params[key] = value;

  return params;
};

const customHouseUuid = v4();
export const customHouse: TLibrary = {
  libraryUuid: customHouseUuid,
  uuid: customHouseUuid,
  icon: 'house-3d',
  title: 'Custom Home',
  subtitle: formatSubtitle(0, 0),
  type: 'Area',
  key: customHouseUuid,
  ...getCustomParameters('isCustomHouse', true),
  description: 'A home with no assets attached - configure and add custom assets',
};

const customPVUuid = v4();
export const customPV: TLibrary = {
  libraryUuid: customPVUuid,
  uuid: customPVUuid,
  icon: 'solar-3d',
  title: 'Custom PV',
  subtitle: formatSubtitle(0, 1),
  type: 'PV',
  key: customPVUuid,
  ...getCustomParameters('isCustomPV', true),
  description: `Add Custom PV \n By default the generation is calculated according to the location and capacity, powered by energydatamap.com`,
};

const customLoadUuid = v4();
export const customLoad: TLibrary = {
  libraryUuid: customLoadUuid,
  uuid: customLoadUuid,
  icon: 'plug-3d',
  title: 'Custom Load',
  subtitle: formatSubtitle(0, 1),
  type: 'Load',
  key: customLoadUuid,
  ...getCustomParameters('isCustomLoad', true),
  description: `Add Custom Load \n By default the generation is calculated according to the location and capacity, powered by energydatamap.com`,
};

const customHeatPumpUuid = v4();
export const customHeatPump: TLibrary = {
  libraryUuid: customHeatPumpUuid,
  uuid: customHeatPumpUuid,
  icon: 'heatpump-3d',
  title: 'Custom Heat Pump',
  subtitle: formatSubtitle(0, 1),
  type: 'HeatPump',
  key: customHeatPumpUuid,
  ...getCustomParameters('isCustomHeatPump', true),
  description: `Add Custom Heat Pump \n By default the generation is calculated according to the location and capacity, powered by energydatamap.com`,
};

const customWindTurbineUuid = v4();
export const customWindTurbine: TLibrary = {
  libraryUuid: customWindTurbineUuid,
  uuid: customWindTurbineUuid,
  icon: 'wind-turbine-3d',
  title: 'Custom Wind Turbine',
  subtitle: formatSubtitle(0, 1),
  type: 'WindTurbine',
  key: customWindTurbineUuid,
  ...getCustomParameters('isCustomWindTurbine', true),
  description: `Add Custom Wind Turbine`,
};

const customSmartMeterUuid = v4();
export const customSmartMeter: TLibrary = {
  libraryUuid: customSmartMeterUuid,
  uuid: customSmartMeterUuid,
  icon: 'smart-meter-3d',
  title: 'Custom Smart Meter',
  subtitle: formatSubtitle(0, 1),
  type: 'SmartMeter',
  key: customSmartMeterUuid,
  ...getCustomParameters('isCustomSmartMeter', true),
  description: `Add Custom Smart Meter`,
};

export const selectLibraryOptions: TSelectedLibraryOptions = [
  {
    label: 'All',
    value: null,
  },
  {
    label: 'GS_y Library',
    value: LibraryTypesGraphql.GsyLibrary,
  },
  {
    label: 'Public Library',
    value: LibraryTypesGraphql.PublicLibrary,
  },
  {
    label: 'My Library',
    value: LibraryTypesGraphql.MyLibrary,
  },
];
